import script from "./StylingAndComfortFrameAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./StylingAndComfortFrameAgreement.vue?vue&type=script&setup=true&lang=js"

import "./StylingAndComfortFrameAgreement.vue?vue&type=style&index=0&id=dfbd929e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfbd929e"]])

export default __exports__